module.exports = __webpack_public_path__ + "static/media/eventSettings.ab298c0d.graphql";